import { render, staticRenderFns } from "./AddBrochureModal.vue?vue&type=template&id=488b85bc&"
import script from "./AddBrochureModal.vue?vue&type=script&lang=js&"
export * from "./AddBrochureModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports